import actionTypes from '../../actionTypes'
import initial from '../../initial'

const privateEmail = (state = initial.privateEmail, action) => {
  switch (action.type) {
  case actionTypes.SET_SELECTED_ALIAS:
    return { ...state, selectedAlias: action.payload }
  default:
    return state
  }
}

export default privateEmail
